// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__33WXE","vLegacy":"SelectSecondary_vLegacy__3uLRe","error":"SelectSecondary_error__2MFne","disabled":"SelectSecondary_disabled__1iRBx"};